import type { LucideIcon } from 'lucide-react'

interface DocPageHeaderProps {
  readonly icon: LucideIcon
  readonly title: string
}

export function DocPageHeader({ icon: Icon, title }: DocPageHeaderProps) {
  return (
    <header className="flex h-12 shrink-0 items-center gap-2 border-b px-4">
      <Icon className="h-4 w-4 text-muted-foreground" />
      <h1 className="text-base font-medium">{title}</h1>
    </header>
  )
}
